//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum OrderStatus {

  Created = 1,

  Pending = 2,

  Complete = 3,

  Unsucessful = 4,

}

export default OrderStatus;